/*
 *
 * File: index.js
 *
 * Purpose: Combine all multistop (app) reducers.
 *
 * Autor:   Thomas Burgard (Software development)
 * Created: 23.02.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import { combineReducers } from "redux";
import userReducer from "./users_reducer";
import languageReducer from "./languages_reducer";
import bookingReducer from "./bookings_reducer";
import passengerReducer from "./passenger_reducer";

/**
 * Combine all booking (app) reducers.
 */
const appReducers = combineReducers({
  userReducer,
  passengerReducer,
  languageReducer,
  bookingReducer,
});

export default appReducers;
